import { DesignSystem } from '@/src/design-system'
import { View, Text, StyleSheet } from 'react-native'
import { PartnerNetworkRow } from '@/src/experiences/rewards/components/PartnerNetworkRow'
import { typography } from '@/src/common/theme'
import { OneworldIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/OneworldIcon'
import { StarAllianceIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/StarAllianceIcon'
import { SkyTeamIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/SkyTeam'
import { ScandinavianAirlinesIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/ScandinavianAirlinesIcon'
import { AeromexicoIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/AeromexicoIcon'
import { CathayPacificIcon } from './CathayPacificIcon'
import { FinnairIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/FinnairIcon'
import { VietnamAirlinesIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/VietnamAirlinesIcon'
import { AirCanadaIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/AirCanadaIcon'
import { ThaiAirwaysIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/ThaiAirwaysIcon'
import { AirIndiaIcon } from '@/src/experiences/rewards/components/airlineAlliancesCard/AirIndiaIcon'
import type { ComponentProps } from 'react'

const airlineAlliances = [
  { network: <OneworldIcon />, partners: [<CathayPacificIcon />, <FinnairIcon />] },
  {
    network: <SkyTeamIcon />,
    partners: [<AeromexicoIcon />, <ScandinavianAirlinesIcon />, <VietnamAirlinesIcon />],
  },
  {
    network: <StarAllianceIcon />,
    partners: [<AirCanadaIcon />, <ThaiAirwaysIcon />, <AirIndiaIcon />],
  },
] as const satisfies ComponentProps<typeof PartnerNetworkRow>[]

export function RewardsComponentsAirlineAlliancesCard() {
  return (
    <DesignSystem.Card style={styles.container}>
      <View style={styles.section}>
        <Text style={typography['heading/heading5']}>Airline Alliances</Text>
        <Text style={typography['paragraph/sm']}>
          Transfer your Mesa Points to any of the following airline programs:
        </Text>
      </View>
      <View style={styles.section}>
        {airlineAlliances.map((props, index) => (
          <PartnerNetworkRow key={index} {...props} />
        ))}
      </View>
      <View style={styles.footer}>
        <Text style={typography['heading/heading5']}>& More...</Text>
      </View>
    </DesignSystem.Card>
  )
}

const styles = StyleSheet.create({
  container: {
    gap: 24,
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 16,
    paddingRight: 16,
  },
  section: {
    gap: 16,
  },
  footer: {
    alignItems: 'center',
  },
})
